import { Typography } from "@mui/material";
import * as React from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitle, getFormFieldTitleColor } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormStringArrayProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    selectSubSectionValuesByTitle: boolean;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormStringArray extends React.Component<ITaskDynamicFormStringArrayProp, {}> {
    handleChange = (selectedIds: string[]) => {
        const newValue = new TaskDataRowCol(this.props.taskDataRowCol);
        newValue.valueStr = JSON.stringify(selectedIds);
        this.props.onChange(newValue);
    };
    
    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        const options = !Base.isNullOrUndefined(typeCol.options) && typeCol.options.length > 0
            ? typeCol.options.map(i => IdTitle.createIdTitle(i, i))
            : (!Base.isNullOrUndefined(typeCol.idOptions) && typeCol.idOptions.length > 0
                ? typeCol.idOptions
                : null);
        const valueIds: string[] = dataCol?.valueStr ? JSON.parse(dataCol?.valueStr) : [];
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{valueIds.length > 0 ? options.filter(i => valueIds.indexOf(i.id) > -1).map(i => i.title).join(", ") : ""}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<CheckboxDropdown
                            disabled={props.colIsReadOnly}
                            selectedIds={valueIds}
                            selectSubSectionValuesByTitle={typeCol.selectOptionsSubSectionValuesByTitle}
                            required={typeCol.required}
                            toggleAll={true}
                            values={options}
                            onChange={this.handleChange}
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}